const ContactPage = () => {
  return (
    <div>
      <h1>Contact</h1>
      <p>Email Jeff at: <a href="mailto:doylesbreakroomservices@gmail.com">doylesbreakroomservices@gmail.com</a></p>
    </div>
  );
};

export default ContactPage;

